<template>
  <div class="footviewcon">
	  <div class="foottop">
		  <div class="concar">
			  <div class="listqr">
			  	 <img :src="$imgUrl + informdata.qrCode_dictText" />
			  </div>
			  <div class="lista">
			  	 <img src="../../static/index/footimga.png" />
			  </div>
			  <div class="listb">
			  	 <img src="../../static/index/footimgb.png" />
			  </div>
			  <div class="f-row-start-b">
				  <div class="listc">
					<div>主办单位：{{informdata.organizer}}</div>
					<div class="mt-05">地址：{{informdata.contactAddress}}</div>
					<div class="mt-05">传真：{{informdata.fax}}</div>
					<div class="mt-05">{{informdata.copyright}} All Rights Reserved. Designed</div>
					<div class="mt-05">技术支持：{{informdata.technicalSupport}}</div>

				</div>
				<div class="listd">
					<!-- <div>
						<img src="../../static/index/footimgc.png" />
					</div> -->
					<div class="name">直属机关纪委</div>
					<div class="a">举报邮箱:{{informdata.provincialPartyCommitteePhone}}</div>
					<div class="b">举报电话：{{informdata.provincialPartyCommitteeEmail}}</div>
				</div>
				<div class="liste">
					<!-- <div>
						<img src="../../static/index/footimgd.png" />
					</div> -->
					<div class="name">纪检监察组</div>
					<div class="a">举报网址:{{informdata.disciplineInspectionCommissionEmail}}</div>
					<div class="b">举报电话：{{informdata.disciplineInspectionCommissionPhone}}</div>
				</div>
			  </div>
		  </div>
	  </div>
	  <div class="footbottom">
	  	 <span @click="navone">青海ICP备{{informdata.icp}}</span>
		 <div class="imgcon">
			 <img @click="navtwo" class="img" src="../../static/index/footimge.png" />
		 </div>

		 <span @click="navtwo">青公网安备{{informdata.networkSafety}}</span>

	  </div>

  </div>
</template>

<script>
export default {
  name: "footviewcon",
  data() {
		return {
			informdata:{},

		};
  },

  created() {

  },

  mounted() {
	  this.getinformcon();

  },

  methods: {
		getinformcon(){
			var that = this;
			this.$get(`web/externallink/ypExternalLink/setting`).then(res=>{
				  if(res.success){
						that.informdata = res.result
				  }
			})
		},

		navone() {
		   window.open("https://beian.miit.gov.cn/#/Integrated/index");
		},

		navtwo() {
		   window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000001");
		}

  }
};
</script>

<style scoped lang="scss">
.f-row-start-b{
	display: flex;
	justify-content: space-between;
	align-content: flex-start;
	align-items: flex-start;
}
.footviewcon {
	position: relative;
    z-index: 100;
	.foottop{
		width: 100%;
		height: 247px;
		background: #434343;
		display: flex;
		align-items: center;
		justify-content: center;
		.concar{
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			font-weight: 400;
			color: #FFFFFF;
			.listqr{
				width: 200px;
				display: flex;
				align-items: center;
				justify-content: center;
				img{
					width: 85px;
					height:85px;
				}
			}
			.lista{
				width: 100px;
				display: flex;
				align-items: center;
				justify-content: center;
				img{
					width: 62px;
					height:78px;
				}
			}
			.listb{
				width: 160px;
				margin-right: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				img{
					width: 144px;
					height:51px;
					padding-right: 20px;
					border-right: 1px solid #FFFFFF;
				}
			}
			.listc{
				width: 350px;
				.mt-05{
					margin-top: 5px;
				}
			}
			.listd,.liste{
				padding: 0 10px;
				
				img{
					width:75px;
					height:75px;
				}
				.name{
					font-size: 16px;
					font-weight: 400;
					color: #FFFFFF;
				}
				.a,.b{
					opacity: 0.5;
					margin-top: 5px;
				}
			}
		}
	}

	.footbottom{
		width: 100%;
		height:44px;
		display: flex;
		align-items: center;
		justify-content: center;
		// flex-direction: column;
		text-align: center;
		background: #1B1B1B;
		font-size: 12px;
		font-weight: 400;
		color: #FBFBFB;
		.imgcon{
			margin-left: 40px;
			margin-right:5px;
			img{
				cursor: pointer;
				height: 18px;
				width: 18px;
			}
		}
		span{
			opacity: 0.5;
			cursor: pointer;
		}
	}
}

</style>
